import { useLayoutEffect } from 'react'
import { v4 } from 'uuid'
import { useFloorplanStore } from '@editor/stores'

const useHideFloorplanElements = (ids: string[] | string | null | undefined) => {
  const addHiddenFloorplanElementIdGroup = useFloorplanStore(
    state => state.addHiddenFloorplanElementIdGroup,
  )
  const removeHiddenFloorplanElementIdGroup = useFloorplanStore(
    state => state.removeHiddenFloorplanElementIdGroup,
  )

  useLayoutEffect(() => {
    if (!ids || ids.length === 0) return

    const actualIds = Array.isArray(ids) ? ids : [ids]
    const uuid = v4()

    addHiddenFloorplanElementIdGroup(uuid, actualIds)

    return () => {
      removeHiddenFloorplanElementIdGroup(uuid)
    }
  }, [addHiddenFloorplanElementIdGroup, removeHiddenFloorplanElementIdGroup, ids])
}

export default useHideFloorplanElements
